export const TEACHER_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ON_LEAVE: 'on_leave'
} as const;

export const TEACHER_INSTRUCTOR_TYPES = {
  FULLTIME: 'fulltime',
  PARTTIME: 'parttime',
  GUEST: 'guest'
} as const;

export const TEACHER_CLASSIFICATIONS = {
  TEACHER: 'teacher',
  ADMIN: 'admin',
  PRINCIPAL: 'principal'
} as const;

export const TEACHER_UNITS = [
  'Khoa Công nghệ thông tin',
  'Khoa Kinh tế',
  'Khoa Ngoại ngữ',
  'Khoa Toán - Lý',
  'Khoa Hóa - Sinh',
  'Khoa Văn - Sử - Địa',
  'Khoa Thể dục - Quốc phòng',
  'Phòng Đào tạo',
  'Phòng Tổ chức - Hành chính',
  'Phòng Tài chính - Kế toán',
  'Phòng Công tác học sinh sinh viên',
  'Phòng Khảo thí và Kiểm định chất lượng',
  'Phòng Quản lý khoa học và Công nghệ',
  'Phòng Hợp tác quốc tế',
  'Phòng Thanh tra',
  'Phòng Pháp chế',
  'Phòng Tổ chức cán bộ',
  'Phòng Tài chính',
  'Phòng Vật tư - Thiết bị',
  'Phòng Công nghệ thông tin',
  'Phòng Quản lý đào tạo',
  'Phòng Quản lý sinh viên',
  'Phòng Quản lý sau đại học',
  'Phòng Quản lý nghiên cứu khoa học',
  'Phòng Quản lý hợp tác quốc tế',
  'Phòng Quản lý tài chính',
  'Phòng Quản lý nhân sự',
  'Phòng Quản lý tài sản',
  'Phòng Quản lý cơ sở vật chất',
  'Phòng Quản lý thông tin',
  'Phòng Quản lý chất lượng',
  'Phòng Quản lý đào tạo từ xa',
  'Phòng Quản lý đào tạo liên thông',
  'Phòng Quản lý đào tạo văn bằng 2',
  'Phòng Quản lý đào tạo sau đại học',
  'Phòng Quản lý nghiên cứu khoa học',
  'Phòng Quản lý hợp tác quốc tế',
  'Phòng Quản lý tài chính',
  'Phòng Quản lý nhân sự',
  'Phòng Quản lý tài sản',
  'Phòng Quản lý cơ sở vật chất',
  'Phòng Quản lý thông tin',
  'Phòng Quản lý chất lượng'
] as const;
